import React, { useContext, useEffect, useState } from "react";
import { Modal, Form, Row, Col, Button, Dropdown, Card } from "react-bootstrap";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { UserContext } from "../../context/UserContextProvider";
import APIServicenew from "../../utils/APIGeneralService";
import { ToastContainer, toast } from "react-toastify";
import { capitalizeFirstLetter } from "../../utils/Helper";

const AddTarget = () => {
  const { id } = useParams();
  const location = useLocation();
  const { row } = location.state || {};
  const APIServices = new APIServicenew(process.env.REACT_APP_OTHER_API_URL);
  const authToken = process.env.REACT_APP_authToken;
  const { accessToken, logout } = useContext(UserContext);
  const headers = {
    "auth-token": authToken,
    authorization: accessToken,
  };
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    product_id: "",
    member_id: "",
    year: "",
    month: "",
    target: "",
    achievement: "",
    description: "",
  });
  const [productList, setProductList] = useState([]);
  const [MemberList, setMemberList] = useState([]);
  const [roleList, setRoleList] = useState([]);

  useEffect(() => {
    handleProductList();
    fetchMember();
  }, []);

    useEffect(() => {
      if (id) {
        if (row) {
          setFormData({
            product_id: row.product_id,
            member_id: row.member_id,
            year: row.year,
            month: row.month,
            target: row.target,
            achievement: row.achieved,
            description: row.description,
          });
        }
      }
    }, [id, row]);
  const handleProductList = async (page = 1) => {
    try {
      const response = await APIServices.get(
        `/admin/product/list?offset=0&limit=1000&sort_by=name&status=Active`,
        headers
      );
      if (response?.status === 200) {
        const data1 = response?.data?.list || [];
        setProductList(data1);
      } else if (response?.status === 401) {
        logout();
        navigate("/");
      } else {
        setProductList([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setProductList([]);
    }
  };

  const fetchMember = async () => {
    try {
      const response = await APIServices.get(
        `/admin/member/short_list`,
        headers
      );
      if (response?.status === 200) {
        setMemberList(response?.data?.list);
      } else {
        setMemberList([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: "" });
  };

  const validate = () => {
    const newErrors = {};

    if (!formData.product_id) {
      newErrors.product_id = "Product is required.";
    }
    if (!formData.member_id) {
      newErrors.member_id = "Member is required.";
    }
    if (!formData.description) {
      newErrors.description = "Description is required.";
    }

    if (!formData.target) {
      newErrors.target = "Target is required.";
    }

    if (!formData.month) {
      newErrors.month = "month is required.";
    }

    if (!formData.year) {
      newErrors.year = "year is required.";
    } else if (formData.year < 2020 || formData.year > 2099) {
      newErrors.year = "Year must be between 2020 and 2099.";
    }

    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validate();

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setErrors({});

    const {product_id ,member_id ,month ,year ,target ,achievement ,description} = formData;
    let updatedFormData = {
      product_id:product_id,
      member_id:member_id,
      month:month,
      year:year,
      description: description,
      target: target,
    };
  
    if (achievement) {
      updatedFormData.achieved = achievement
    }

    const formDataToSubmit = new FormData();
    Object.keys(updatedFormData).forEach((key) => {
      formDataToSubmit.append(key, updatedFormData[key]);
    });
    // return;
    try {
      if (id) {
        const formData1 = { ...updatedFormData };
        formData1.id = id;
        const res = await APIServices.post(
          `/admin/target/update`,
          formData1,
          headers
        );
        if (res?.data?.status === true) {
          showToast(res?.data?.message || "Success", "success");
          setTimeout(() => {
            navigate("/admin/target-achievement");
          }, 2000);
        } else if (res?.status === 401) {
          logout();
          navigate("/");
        } else {
          showToast(res?.data?.message || "Something went wrong.", "error");
        }
      } else {
        const res = await APIServices.post(
          "/admin/target/add",
          updatedFormData,
          headers
        );
        if (res?.data?.status === true) {
          showToast(res?.data?.message || "Success", "success");
          setTimeout(() => {
            navigate("/admin/target-achievement");
          }, 2000);
        } else {
          showToast(res?.data?.message || "Something went wrong.", "error");
        }
      }
    } catch (error) {
      console.error("API call error:", error);
      showToast("An unexpected error occurred. Please try again.", "error");
    }
  };
  const showToast = (message, type) => {
    toast(message, {
      position: "top-right",
      autoClose: 2000,
      type,
      hideProgressBar: false,
      closeOnClick: true,
    });
  };
  return (
    <>
      <div className="addmom_inner">
        <div className="addmom_header d-flex justify-content-start mb-3">
          <h1 className="font_blue_18 font-600">Add Target/Achievement</h1>
        </div>

        <Card className="mom_form">
          <Card.Body>
            <Form className="">
              <Row>
                <Col md={6} lg={6}>
                  <Form.Group className="mb-3">
                    <Form.Label className="font_blue_14 font-500 mb-2">
                      Product
                    </Form.Label>
                    <Form.Select name="product_id"value={formData.product_id} onChange={handleChange}>
                      <option value="">Select Product</option>
                      {productList?.map((item) => (
                        <option key={item.id} value={item.id}>
                          {capitalizeFirstLetter(item.name)}
                        </option>
                      ))}
                    </Form.Select>
                    {errors.product_id && (
                      <div className="text-danger">{errors.product_id}</div>
                    )}
                  </Form.Group>
                </Col>

            

                <Col md={6} lg={6}>
                  <Form.Group className="mb-3">
                    <Form.Label className="font_blue_14 font-500 mb-2 ">
                      Member
                    </Form.Label>
                    <Form.Select name="member_id" value={formData.member_id} onChange={handleChange}>
                      <option value="">Select Member</option>
                      {MemberList?.map((item) => (
                        <option key={item.id} value={item.id}>
                          {capitalizeFirstLetter(item.fullname)}
                        </option>
                      ))}
                    </Form.Select>
                    {errors.member_id && (
                      <div className="text-danger">{errors.member_id}</div>
                    )}
                  </Form.Group>
                </Col>

                {/* Month Dropdown */}
                <Col md={3} lg={3}>
                  <Form.Group className="mb-3">
                    <Form.Label className="font_blue_14 font-500 mb-2">
                      Month
                    </Form.Label>
                    <Form.Select
                      name="month"
                      onChange={handleChange}
                      value={formData.month}
                    >
                      <option value="">Select Month</option>
                      {[
                        { name: "January", value: 1 },
                        { name: "February", value: 2 },
                        { name: "March", value: 3 },
                        { name: "April", value: 4 },
                        { name: "May", value: 5 },
                        { name: "June", value: 6 },
                        { name: "July", value: 7 },
                        { name: "August", value: 8 },
                        { name: "September", value: 9 },
                        { name: "October", value: 10 },
                        { name: "November", value: 11 },
                        { name: "December", value: 12 },
                      ].map((month) => (
                        <option key={month.value} value={month.value}>
                          {month.name}
                        </option>
                      ))}
                    </Form.Select>
                    {errors.month && (
                      <div className="text-danger">{errors.month}</div>
                    )}
                  </Form.Group>
                </Col>
                {/* Year Dropdown */}
                <Col md={3} lg={3}>
                  <Form.Group className="mb-3">
                    <Form.Label className="font_blue_14 font-500 mb-2">
                      Year
                    </Form.Label>
                    <Form.Select
                      name="year"
                      onChange={handleChange}
                      value={formData.year}
                    >
                      <option value="">Select Year</option>
                      {Array.from({ length: 80 }, (_, index) => {
                        const year = 2020 + index;
                        return (
                          <option key={year} value={year}>
                            {year}
                          </option>
                        );
                      })}
                    </Form.Select>
                    {errors.year && (
                      <div className="text-danger">{errors.year}</div>
                    )}
                  </Form.Group>
                </Col>
                <Col md={6} lg={6}>
                  <Form.Group controlId="Target">
                    <Form.Label className="font_blue_14 font-500 mb-2 ">
                      Target
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="target"
                      placeholder="Enter Target"
                      value={formData.target}
                      onChange={handleChange}
                      pattern="[0-9]*" // Allows only numeric input
                      onKeyDown={(e) => {
                        if (!/^[0-9]$/.test(e.key) && e.key !== "Backspace") {
                          e.preventDefault(); // Block non-numeric input
                        }
                      }}
                      maxLength={8}
                    />
                    {errors.target && (
                      <div className="text-danger">{errors.target}</div>
                    )}
                  </Form.Group>
                </Col>
                <Col md={12} lg={12}>
                  <Form.Group className="mb-3" controlId="Achievement">
                    <Form.Label className="font_blue_14 font-500 mb-2 ">
                      Achievement
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="achievement"
                      placeholder="Enter Achievement"
                      value={formData.achievement}
                      onChange={handleChange}
                      pattern="[0-9]*" // Allows only numeric input
                      onKeyDown={(e) => {
                        if (!/^[0-9]$/.test(e.key) && e.key !== "Backspace") {
                          e.preventDefault(); // Block non-numeric input
                        }
                      }}
                      maxLength={8}
                    />
                  </Form.Group>
                </Col>

                <Col md={12} lg={12}>
                  <Form.Group className="mb-3">
                    <Form.Label className="font_blue_14 font-500 mb-2 ">
                      Description
                    </Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={4}
                      name="description"
                      placeholder="Write here..."
                      value={formData.description}
                      onChange={handleChange}
                      style={{ height: "120px" }}
                    />
                    {errors.description && (
                      <div className="text-danger">{errors.description}</div>
                    )}
                  </Form.Group>
                </Col>
              </Row>

              <div className="d-flex justify-content-end gap-2">
                <Button
                  className="btn blue_border"
                  onClick={() => navigate("/admin/target-achievement")}
                >
                  Cancel
                </Button>
                <Button className="btn red_button" onClick={handleSubmit}>
                  Save
                </Button>
              </div>
            </Form>
          </Card.Body>
        </Card>
      </div>
      <ToastContainer />
    </>
  );
};

export default AddTarget;
